<template>
      <div class="account-content">
            <div class="container">
                <div class="account-box">
                    <div class="account-wrapper">

                        <div class="lock-user">
                            <img alt="" src="assets/img/profiles/avatar-02.jpg" class="rounded-circle">
                            <h4>John Doe</h4>
                        </div>


                        <form action="admin-dashboard.html">
                            <div class="form-group">
                                <label>Password</label>
                                <input class="form-control" type="password">
                            </div>
                            <div class="form-group text-center">
                                <button class="btn btn-primary account-btn" type="submit">Enter</button>
                            </div>
                            <div class="account-footer">
                                <p>Sign in as a different user? <a href="index.html">Login</a></p>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    created() {
        document.getElementById("body").classList.remove("account-page");
    },
    methods:{
        login(){
            this.$router.push({path:"/dashboard"});
        }
    }
}
</script>
